import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Adidas = ({featuredProjectsList}) => {
  const project = getProject('adidas');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            video: '163383061',
            posterVideo: '215749392'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="street-to-street">Street to street</h2>
          <p>
            Nine connected LED cubes were placed in the busy streets of London,
            Berlin, Stockholm, Milan, Barcelona, Hamburg, Rotterdam, Frankfurt
            and Munich. Each cube was an interactive canvas, showcasing the shoe
            and allowing passers-by to change different city views with their
            smartphones.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170509173442/large_2.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170509173453/large_5.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170509173532/large_41.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="milestones">Milestones</h2>
          <ul>
            <li>
              The cube installation helped adidas reach over 2,000,000+ fans via
              237,000+ posted #NMD photos on Instagram.
            </li>
            <li>
              The shoe sold out internationally on the first day, making it one
              of the most successful launches in the company’s history.
            </li>
            <li>FWA Site of the Day</li>
            <li>FWA / Adobe - Cutting Edge Project of the Month</li>
          </ul>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170509173553/large_8.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170509173608/large_9.jpg'
          }}
        />

        <Image
          className="g-row //images.yourmajesty.co/20170509173608/large_9.jpg"
          component={{
            image: '//images.yourmajesty.co/20170509173623/large_7.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170509173730/large_3.jpg',
            caption:
              'Mobile app for fan-to-fan communication through the cubes.'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="partners">Partners</h2>
          <p>
            Act Normal
            <br />
            Naivi
            <br />
            LedLease
          </p>
        </AnimateIn>

        <LinkList
          component={{
            title: 'Press',
            useLinksDirectly: true,
            links: [
              {
                title:
                  'adidas NMD Cube Project Uses UE4 to Push the Boundaries of Marketing, Engage Community',
                url:
                  'https://www.unrealengine.com/showcase/adidas-nmd-cube-project-uses-ue4-to-push-the-boundaries-of-marketing-engage-community',
                source: 'Unreal Engine'
              },
              {
                title:
                  'adidas Installed NMD Cubes in 9 Major Cities for One Reason',
                url: 'http://bae.hypebeast.com/2016/4/adias-nmd-cube',
                source: 'Hypebeast'
              },
              {
                title:
                  'adidas’ Interactive NMD Cubes Made it One of the Most Successful Shoes Ever',
                url:
                  'https://twitter.com/highsnobiety/status/723075878540873728',
                source: 'Highsnobiety'
              }
            ]
          }}
        />

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Brand Strategy',
                  'Collaborative Working Sessions',
                  'Communications Strategy',
                  'Content Strategy',
                  'Creative Strategy',
                  'Launch Strategy',
                  'Prototyping & Validation',
                  'Research',
                  'Social Strategy',
                  'Technical Strategy'
                ]
              },

              {
                title: 'Design',
                items: [
                  '3D Animation',
                  '3D Design',
                  'Art Direction',
                  'Creative Direction',
                  'Motion Design',
                  'Sound Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Content Management System',
                  'Front-end Development',
                  'Functional Prototyping',
                  'Localization',
                  'Systems Architecture'
                ]
              },

              {
                title: 'Delivery',
                items: [
                  'Integration Support',
                  'Launch',
                  'Monitoring',
                  'Staff Training & Support'
                ]
              },

              {
                title: 'Content',
                items: ['Animation']
              },

              {
                title: 'Experiential',
                items: [
                  'Custom Hardware',
                  'Hardware Specification',
                  'Immersive Environment',
                  'Installation Prototyping',
                  'Interactive Environment',
                  'Video Installation'
                ]
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Adidas;
